import { collapseSelectedRuleEntriesByCommonPrefix } from '@shared/utils/policyRules';

export default {
  data() {
    return {
      selectedPolicyRules: {},
      policyRuleEdits: {},
      policyGroupRuleEdits: {}
    };
  },
  methods: {
    getPolicySelectionRules() {
      return [];
    },
    getPolicyRuleKey(groupIndex, ruleIndex) {
      return `${groupIndex}-${ruleIndex}`;
    },
    getGroupedPolicyRuleKey(groupIndex, groupId) {
      return `${groupIndex}-${groupId}`;
    },
    resetPolicyRuleSelection(groupCount, isInitiallySelected = () => true) {
      const selected = {};
      for (let groupIndex = 0; groupIndex < groupCount; groupIndex += 1) {
        this.getPolicySelectionRules(groupIndex).forEach((rule, ruleIndex) => {
          selected[this.getPolicyRuleKey(groupIndex, ruleIndex)] =
            isInitiallySelected(rule, groupIndex, ruleIndex);
        });
      }
      this.selectedPolicyRules = selected;
      this.policyRuleEdits = {};
      this.policyGroupRuleEdits = {};
    },
    setAllPolicyRulesSelected(groupCount, selected) {
      for (let groupIndex = 0; groupIndex < groupCount; groupIndex += 1) {
        this.getPolicySelectionRules(groupIndex).forEach((_, ruleIndex) => {
          this.$set(
            this.selectedPolicyRules,
            this.getPolicyRuleKey(groupIndex, ruleIndex),
            selected
          );
        });
      }
      this.onPolicyRuleSelectionChanged();
    },
    onTogglePolicyRule(groupIndex, ruleIndex) {
      const rule = this.getPolicySelectionRules(groupIndex)[ruleIndex];
      if (!rule) return;
      const key = this.getPolicyRuleKey(groupIndex, ruleIndex);
      this.$set(
        this.selectedPolicyRules,
        key,
        this.selectedPolicyRules[key] === false
      );
      this.onPolicyRuleSelectionChanged();
    },
    onChangePolicyRule(groupIndex, change) {
      const { ruleIndex, field, value } = change;
      const rule = this.getPolicySelectionRules(groupIndex)[ruleIndex];
      if (!rule) return;
      const key = this.getPolicyRuleKey(groupIndex, ruleIndex);
      this.$set(this.policyRuleEdits, key, {
        ...rule,
        ...(this.policyRuleEdits[key] || {}),
        [field]: value
      });
      this.onPolicyRuleSelectionChanged();
    },
    onChangeGroupedPolicyRule(groupIndex, change) {
      const { groupId, field, value } = change;
      const key = this.getGroupedPolicyRuleKey(groupIndex, groupId);
      this.$set(this.policyGroupRuleEdits, key, {
        ...(this.policyGroupRuleEdits[key] || {}),
        [field]: value
      });
      this.onPolicyRuleSelectionChanged();
    },
    getSelectedPolicyRules(groupIndex) {
      const entries = this.getPolicySelectionRules(groupIndex).map(
        (rule, ruleIndex) => ({
          rule,
          ruleIndex
        })
      );
      return collapseSelectedRuleEntriesByCommonPrefix(entries, {
        isSelected: (entry) =>
          this.selectedPolicyRules[
            this.getPolicyRuleKey(groupIndex, entry.ruleIndex)
          ] !== false,
        getRuleEdit: (entry) =>
          this.policyRuleEdits[
            this.getPolicyRuleKey(groupIndex, entry.ruleIndex)
          ],
        getGroupEdit: (cluster) =>
          this.policyGroupRuleEdits[
            this.getGroupedPolicyRuleKey(groupIndex, cluster.groupId)
          ]
      });
    },
    onPolicyRuleSelectionChanged() {}
  }
};
